var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DriveTreeView',{attrs:{"folder-id":_vm.data.folderID || _vm.folderId || null,"hide-create-folder":"","hide-upload-file":"","hide-setting":"","download-icon-with-label":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }